<template>
  <PageWrap :page-title="pageTitle">
    <LoadingIndicator
      v-if="loadingData"
      class="mt-5"
    />

    <template v-else>
      <b-row>
        <b-col>
          <b-row class="mb-3">
            <b-col cols="12">

            </b-col>
            <b-col cols="12">

              <PropertyTypeForm
                :data="formData"
                :editing="isEditing"
                :errors="formErrors"
                @update="updateForm"
              />

            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <BfButton v-if="!isEditing" @click="createProperty">Guardar</BfButton>
        <BfButton
        v-if="isEditing"
        variant="red"
        @click="showDeleteModal"
      >
        Eliminar
      </BfButton>

      <DeleteWarningModal
        v-model="displayDeleteModal"
        title="¿Desea eliminar este tipo de inmueble?"
        @confirm-deletion="deleteProperty"
      />
    </template>
  </PageWrap>
</template>

<script>
import FormSectionHeader from '@/components/FormSectionHeader';
import LoadingIndicator from '@/components/LoadingIndicator';
import PropertyTypeForm from '@/components/FormGroups/PropertyTypeForm';
import PageWrap from '@/components/PageWrap';
import DeleteWarningModal from '@/components/DeleteWarningModal';
import { propertyTypeAPI } from '@/api';

export default {
  name: 'PropertyTypesDetail',

  props: {
    id: {
      type: String,
    },
  },

  data() {
    return {
      formData: {},
      formErrors: {},
      loadingData: false,
      displayDeleteModal: false,
    };
  },

  async created() {
    this.loadingData = true;

    try {
      if (this.isEditing) {
        await this.loadData();
      } else {
        await this.prepareForm();
      }
    } finally {
      this.loadingData = false;
    }
  },

  methods: {
    async loadData() {
      const property = await propertyTypeAPI.get(this.id);
      const {
        data: [propertyData],
      } = property;

      this.formData = propertyData;
    },

    async prepareForm() {
      const { data } = await propertyTypeAPI.preCreate();

      this.formData = data;
    },

    async createProperty() {
      try {
        this.formErrors = {};
        const { data, message } = await propertyTypeAPI.create(this.formData);

        this.$bfNotify({ title: 'Guardado', message, type: 'success' });
        this.$router.replace({ name: 'property', params: { id: `${data.id}` } });
      } catch ({ errors, message }) {
        this.formErrors = errors;
        this.$bfNotify({ title: 'Error', message: 'Existe un error con tus datos', type: 'error' });
      }
    },

    async updateForm({ key, value }) {
      const newData = { [key]: value };

      if (!this.isEditing) {
        this.formData = { ...this.formData, ...newData };
      } else {
        this.formErrors = {};

        try {
          const { data, message } = await propertyTypeAPI.update({
            id: this.id,
            data: newData,
          });

          this.formData = data;
          this.$bfNotify({ title: 'Actualizado', message, type: 'success' });
        } catch ({ errors }) {
          this.formErrors = errors;
          this.$bfNotify({
            title: 'Error',
            message: 'Existe un error con tus datos',
            type: 'error',
          });
        }
      }
    },

    async deleteProperty() {
      try {
        const { message } = await propertyTypeAPI.delete(this.id);

        this.$bfNotify({ title: 'Eliminado', message, type: 'success' });
        this.$router.replace({ name: 'properties' });
      } catch ({ message }) {
        this.$bfNotify({ title: 'Error', message, type: 'error' });
      }
    },
    async showDeleteModal() {
      this.displayDeleteModal = true;
    },

  },

  computed: {
    isEditing() {
      return !!this.id;
    },

    pageTitle() {
      return this.isEditing
        ? `Tipo de Inmueble: ${this.formData.nombre || ''}`
        : 'Crear tipo de inmueble';
    },
  },

  components: {
    DeleteWarningModal,
    FormSectionHeader,
    LoadingIndicator,
    PageWrap,
    PropertyTypeForm,
  },
};
</script>
